// extracted by mini-css-extract-plugin
export default {"wrap":"MemberStatisticsTotal_wrap__LdDav","line":"MemberStatisticsTotal_line__lffgZ","text":"MemberStatisticsTotal_text__z-Rmb","boxArea":"MemberStatisticsTotal_boxArea__tEII-"};